export type ORDER_STATUS = 'WAITING' 
| 'CHECKED' 
| 'TRANSLATION' 
| 'CUT' 
| 'DECORATION' 
| 'CONNECTED' 
| 'READY_TO_SEND' 
| 'SENT' 
| 'FIRST_MEASUREMENT' 
| 'PICKED_UP' 
| 'BLOCKED'   
| 'PATTERN'
| 'CONFECTION'
| 'RECTIFICATION'
| 'SECOND_MEASUREMENT'
| 'BOWS'
| 'LACE'
| 'LINING'
| 'APRON'
| 'SHAWL'
| 'LOOPS'
| 'HOOKS';

export function getStatusesRaw(): ORDER_STATUS[] {
  return [
    'WAITING', 
    'CHECKED', 
    'TRANSLATION', 
    'CUT', 
    'DECORATION', 
    'CONNECTED', 
    'READY_TO_SEND', 
    'SENT', 
    'FIRST_MEASUREMENT', 
    'PICKED_UP', 
    'BLOCKED', 
    'PATTERN',
    'CONFECTION',
    'RECTIFICATION',
    'SECOND_MEASUREMENT',
    'BOWS',
    'LACE',
    'LINING',
    'APRON',
    'SHAWL',
    'LOOPS',
    'HOOKS',
  ];
}

export function orderStatusToTranslationKeys(status: string | undefined): string {
  switch (status) {
    case 'WAITING':
      return "orders.status.waiting";
    case 'CHECKED':
        return "orders.status.checked";
    case 'TRANSLATION':
        return "orders.status.translation";
    case 'CUT':
        return "orders.status.cut";
    case 'DECORATION':
        return "orders.status.decoration";
    case 'CONNECTED':
        return "orders.status.connected";
    case 'READY_TO_SEND':
        return "orders.status.ready_to_send";
    case 'SENT':
        return "orders.status.sent";
    case 'FIRST_MEASUREMENT':
      return "orders.status.first_measurement";
    case 'PICKED_UP':
      return "orders.status.picked_up";
    case 'BLOCKED':
      return "orders.status.blocked";
    case 'PATTERN':
      return 'orders.status.pattern';
    case 'CONFECTION':
      return 'orders.status.confection';
    case 'RECTIFICATION':
      return 'orders.status.rectification';
    case 'SECOND_MEASUREMENT':
      return 'orders.status.second_measurement';
    case 'BOWS':
      return 'orders.status.bows';
    case 'LACE':
      return 'orders.status.lace';
    case 'LINING':
      return 'orders.status.lining';
    case 'APRON':
      return 'orders.status.apron';
    case 'SHAWL':
      return 'orders.status.shawl';
    case 'LOOPS':
      return 'orders.status.loops';
    case 'HOOKS':
      return 'orders.status.hooks';
    default:
      return "global.unknown";
  }
}

export function orderStatusToColor(status: string | undefined): string {
  const colorMap: { [key: string]: string } = {
    'WAITING': 'bg-gray-500',
    'CHECKED': 'bg-teal-500',
    'TRANSLATION': 'bg-indigo-500',
    'CUT': 'bg-blue-500',
    'DECORATION': 'bg-purple-500',
    'CONNECTED': 'bg-green-500',
    'READY_TO_SEND': 'bg-yellow-500',
    'SENT': 'bg-orange-500',
    'FIRST_MEASUREMENT': 'bg-pink-500',
    'PICKED_UP': 'bg-emerald-500',
    'BLOCKED': 'bg-red-500',
    'PATTERN': 'bg-cyan-500',
    'CONFECTION': 'bg-amber-500',
    'RECTIFICATION': 'bg-lime-500',
    'SECOND_MEASUREMENT': 'bg-rose-500',
    'BOWS': 'bg-violet-500',
    'LACE': 'bg-sky-500',
    'LINING': 'bg-stone-500',
    'APRON': 'bg-zinc-500',
    'SHAWL': 'bg-slate-500',
    'LOOPS': 'bg-neutral-500',
    'HOOKS': 'bg-gray-600'
  };
  
  return colorMap[status || ''] || 'bg-gray-500';
}